import React from "react";

import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import makeStyles from "@mui/styles/makeStyles";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DeviceHubOutlinedIcon from "@mui/icons-material/DeviceHubOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";

import logoWhite from "../../assets/logo-white.png";

export const LS = {
	red: "#990000",
	redLight: "#cc2222",
	redDark: "#660000",
	redGlow: "rgba(153, 0, 0, 0.35)",
	bg: "#0c0608",
	bgCard: "rgba(24, 8, 10, 0.92)",
	text: "#f5e6e8",
	textMuted: "#b8a0a4",
	border: "rgba(153, 0, 0, 0.22)",
};

export const WhatsAppIcon = () => (
	<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
		<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
	</svg>
);

export const InstagramIcon = () => (
	<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
		<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
	</svg>
);

export const CHANNELS = [
	{
		key: "whatsapp-meta",
		label: "WhatsApp oficial",
		hint: "Meta Cloud API",
		icon: <WhatsAppIcon />,
		className: "whatsapp",
	},
	{
		key: "whatsapp-web",
		label: "WhatsApp Web",
		hint: "Não oficial",
		icon: <WhatsAppIcon />,
		className: "whatsappWeb",
	},
	{
		key: "instagram",
		label: "Instagram",
		hint: "Direct & Meta",
		icon: <InstagramIcon />,
		className: "instagram",
	},
	{
		key: "facebook",
		label: "Facebook",
		hint: "Messenger & Meta",
		icon: <FacebookIcon />,
		className: "facebook",
	},
	{
		key: "whatsapp-calling",
		label: "WhatsApp Calling",
		hint: "Integrado ao PABX",
		icon: <PhoneInTalkOutlinedIcon />,
		className: "whatsappCalling",
	},
];

export const DEFAULT_STATS = [
	{
		key: "support",
		value: "24/7",
		label: "Atendimento contínuo",
		icon: AccessTimeIcon,
	},
	{
		key: "channels",
		value: "Multi",
		label: "Canais unificados",
		icon: DeviceHubOutlinedIcon,
	},
	{
		key: "voip",
		value: "VoIP",
		label: "PABX integrado",
		icon: HeadsetMicOutlinedIcon,
	},
];

export const NEW_CLIENT_CONTACT = {
	whatsapp: "553140639927",
	whatsappDisplay: "(31) 4063-9927",
	email: "comercial@life-sip.com.br",
};

export const useAuthPageStyles = makeStyles(theme => ({
	"@keyframes cardEnter": {
		from: { opacity: 0, transform: "translateY(22px) scale(0.96)" },
		to: { opacity: 1, transform: "translateY(0) scale(1)" },
	},
	"@keyframes cardFloat": {
		"0%, 100%": { transform: "translateY(0)" },
		"50%": { transform: "translateY(-6px)" },
	},
	"@keyframes iconPulse": {
		"0%, 100%": { transform: "scale(1)" },
		"50%": { transform: "scale(1.14)" },
	},
	"@keyframes glowDrift": {
		"0%, 100%": { opacity: 0.35, transform: "scale(1)" },
		"50%": { opacity: 0.55, transform: "scale(1.08)" },
	},
	"@keyframes shimmer": {
		"0%": { backgroundPosition: "-200% 0" },
		"100%": { backgroundPosition: "200% 0" },
	},
	"@keyframes badgePulse": {
		"0%, 100%": { boxShadow: `0 0 0 0 ${LS.redGlow}` },
		"50%": { boxShadow: `0 0 0 8px rgba(153, 0, 0, 0)` },
	},
	"@keyframes statGlow": {
		"0%, 100%": { boxShadow: `0 0 0 0 ${LS.redGlow}` },
		"50%": { boxShadow: `0 0 24px ${LS.redGlow}` },
	},
	root: {
		minHeight: "100vh",
		display: "flex",
		background: `radial-gradient(ellipse at 20% 50%, #1a0808 0%, ${LS.bg} 55%, #050304 100%)`,
		overflow: "hidden",
		position: "relative",
	},
	backgroundGlow: {
		position: "absolute",
		borderRadius: "50%",
		filter: "blur(90px)",
		pointerEvents: "none",
		animation: "$glowDrift 8s ease-in-out infinite",
	},
	glowRed: {
		width: 480,
		height: 480,
		background: LS.red,
		top: -140,
		left: -100,
		opacity: 0.4,
	},
	glowRedDark: {
		width: 340,
		height: 340,
		background: LS.redDark,
		bottom: -80,
		left: "22%",
		opacity: 0.5,
		animationDelay: "2s",
	},
	glowAccent: {
		width: 260,
		height: 260,
		background: LS.redLight,
		top: "40%",
		right: "40%",
		opacity: 0.18,
		animationDelay: "4s",
	},
	heroPanel: {
		flex: "1 1 58%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		padding: theme.spacing(6, 8),
		color: LS.text,
		position: "relative",
		zIndex: 1,
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
	},
	brandRow: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(2.5),
		marginBottom: theme.spacing(3),
		padding: theme.spacing(2, 2.5),
		borderRadius: 20,
		background: "linear-gradient(135deg, rgba(153,0,0,0.22) 0%, rgba(24,8,10,0.85) 100%)",
		border: `1px solid rgba(153, 0, 0, 0.45)`,
		boxShadow: `0 12px 40px ${LS.redGlow}, inset 0 1px 0 rgba(255,255,255,0.06)`,
		maxWidth: 520,
	},
	logo: {
		height: 52,
		width: "auto",
		objectFit: "contain",
		filter: "drop-shadow(0 4px 12px rgba(153, 0, 0, 0.4))",
	},
	logoLarge: {
		height: 88,
		width: "auto",
		objectFit: "contain",
		filter: "drop-shadow(0 8px 24px rgba(153, 0, 0, 0.55))",
	},
	brandTextWrap: {
		display: "flex",
		flexDirection: "column",
		gap: 4,
	},
	brandName: {
		fontWeight: 900,
		fontSize: "1.85rem",
		lineHeight: 1.1,
		color: LS.text,
		letterSpacing: 0.5,
		textShadow: "0 2px 16px rgba(153, 0, 0, 0.45)",
	},
	brandNameAccent: {
		fontWeight: 700,
		fontSize: "0.95rem",
		color: LS.redLight,
		letterSpacing: 2.5,
		textTransform: "uppercase",
	},
	brandBadge: {
		display: "inline-flex",
		alignItems: "center",
		gap: 8,
		padding: "6px 14px",
		borderRadius: 999,
		background: "rgba(153, 0, 0, 0.18)",
		border: `1px solid ${LS.border}`,
		color: "#ff8080",
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: 0.8,
		textTransform: "uppercase",
		marginBottom: theme.spacing(2),
		animation: "$badgePulse 2.5s ease-in-out infinite",
	},
	heroTitle: {
		fontWeight: 800,
		fontSize: "2.75rem",
		lineHeight: 1.15,
		marginBottom: theme.spacing(2),
		background: `linear-gradient(135deg, #ffffff 0%, ${LS.redLight} 55%, ${LS.red} 100%)`,
		WebkitBackgroundClip: "text",
		WebkitTextFillColor: "transparent",
	},
	heroSubtitle: {
		fontSize: "1.05rem",
		lineHeight: 1.7,
		color: LS.textMuted,
		maxWidth: 560,
		marginBottom: theme.spacing(4),
	},
	channelGrid: {
		display: "grid",
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
		gap: theme.spacing(2),
		maxWidth: 560,
	},
	channelCard: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1.5),
		padding: theme.spacing(2),
		borderRadius: 16,
		background: LS.bgCard,
		border: `1px solid ${LS.border}`,
		backdropFilter: "blur(12px)",
		opacity: 0,
		position: "relative",
		overflow: "hidden",
		cursor: "default",
		animation: "$cardEnter 0.55s ease forwards, $cardFloat 3.2s ease-in-out infinite",
		transition: "border-color 0.3s ease, box-shadow 0.3s ease",
		"&::before": {
			content: '""',
			position: "absolute",
			inset: 0,
			background:
				"linear-gradient(105deg, transparent 40%, rgba(153,0,0,0.08) 50%, transparent 60%)",
			backgroundSize: "200% 100%",
			opacity: 0,
			transition: "opacity 0.3s ease",
		},
		"&:hover": {
			borderColor: "rgba(153, 0, 0, 0.55)",
			boxShadow: `0 12px 36px ${LS.redGlow}`,
			"&::before": {
				opacity: 1,
				animation: "$shimmer 1.4s ease",
			},
			"& $channelIconWrap": {
				animation: "$iconPulse 0.7s ease",
			},
		},
	},
	channelIconWrap: {
		width: 44,
		height: 44,
		borderRadius: 12,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0,
		transition: "transform 0.3s ease",
	},
	whatsapp: {
		background: "rgba(37, 211, 102, 0.15)",
		color: "#25d366",
	},
	whatsappWeb: {
		background: "rgba(37, 211, 102, 0.08)",
		color: "#1da851",
		border: "1px dashed rgba(37, 211, 102, 0.35)",
	},
	instagram: {
		background: "rgba(225, 48, 108, 0.15)",
		color: "#e1306c",
	},
	facebook: {
		background: "rgba(24, 119, 242, 0.15)",
		color: "#1877f2",
	},
	whatsappCalling: {
		background: "rgba(153, 0, 0, 0.22)",
		color: LS.redLight,
		border: `1px solid ${LS.border}`,
	},
	channelLabel: {
		fontWeight: 600,
		fontSize: 14,
		color: LS.text,
	},
	channelHint: {
		fontSize: 12,
		color: LS.textMuted,
	},
	statsRow: {
		display: "grid",
		gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
		gap: theme.spacing(2),
		marginTop: theme.spacing(4),
		maxWidth: 560,
	},
	statCard: {
		padding: theme.spacing(2, 2.5),
		borderRadius: 18,
		background: "linear-gradient(160deg, rgba(153,0,0,0.28) 0%, rgba(24,8,10,0.95) 100%)",
		border: "1px solid rgba(153, 0, 0, 0.45)",
		boxShadow: `0 8px 28px ${LS.redGlow}`,
		animation: "$statGlow 3s ease-in-out infinite",
		textAlign: "center",
	},
	statIconWrap: {
		width: 40,
		height: 40,
		borderRadius: 12,
		margin: "0 auto 10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		background: "rgba(153, 0, 0, 0.25)",
		color: LS.redLight,
	},
	statValue: {
		display: "block",
		fontSize: "1.65rem",
		fontWeight: 800,
		color: "#fff",
		lineHeight: 1.1,
		marginBottom: 4,
	},
	statLabel: {
		fontSize: 11,
		color: LS.textMuted,
		textTransform: "uppercase",
		letterSpacing: 0.6,
		fontWeight: 600,
	},
	formPanel: {
		flex: "1 1 42%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: theme.spacing(4),
		position: "relative",
		zIndex: 1,
		[theme.breakpoints.down("sm")]: {
			flex: "1 1 100%",
		},
	},
	formCard: {
		width: "100%",
		maxWidth: 440,
		padding: theme.spacing(4.5, 4),
		borderRadius: 24,
		background: LS.bgCard,
		border: `1px solid ${LS.border}`,
		boxShadow: `0 24px 64px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(153,0,0,0.08)`,
		backdropFilter: "blur(20px)",
	},
	mobileLogoWrap: {
		display: "none",
		textAlign: "center",
		marginBottom: theme.spacing(3),
		[theme.breakpoints.down("sm")]: {
			display: "block",
		},
	},
	mobileBrandName: {
		display: "block",
		marginTop: theme.spacing(1),
		fontWeight: 800,
		fontSize: "1.35rem",
		color: LS.text,
	},
	formTitle: {
		fontWeight: 700,
		fontSize: "1.75rem",
		color: LS.text,
		marginBottom: theme.spacing(0.5),
	},
	formSubtitle: {
		color: LS.textMuted,
		marginBottom: theme.spacing(3),
		fontSize: 14,
	},
	newClientCard: {
		marginTop: theme.spacing(3),
		padding: theme.spacing(2.5),
		borderRadius: 16,
		background: "linear-gradient(135deg, rgba(37,211,102,0.12) 0%, rgba(153,0,0,0.18) 100%)",
		border: "1px solid rgba(37, 211, 102, 0.35)",
		boxShadow: "0 8px 32px rgba(37, 211, 102, 0.12)",
	},
	newClientHeader: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		marginBottom: theme.spacing(1.5),
	},
	newClientTitle: {
		fontWeight: 700,
		fontSize: 15,
		color: "#fff",
	},
	newClientText: {
		fontSize: 13,
		color: LS.textMuted,
		marginBottom: theme.spacing(1.5),
		lineHeight: 1.5,
	},
	contactRow: {
		display: "flex",
		alignItems: "center",
		gap: 10,
		marginTop: 8,
		fontSize: 13,
	},
	contactLink: {
		color: "#7dffb0",
		fontWeight: 600,
		textDecoration: "none",
		"&:hover": {
			color: "#a8ffca",
			textDecoration: "underline",
		},
	},
	contactEmailLink: {
		color: LS.redLight,
		fontWeight: 600,
		textDecoration: "none",
		"&:hover": {
			color: "#ff9999",
			textDecoration: "underline",
		},
	},
	textField: {
		marginBottom: theme.spacing(1.5),
		"& .MuiOutlinedInput-root": {
			borderRadius: 12,
			background: "rgba(8, 4, 5, 0.65)",
			color: LS.text,
			"& fieldset": {
				borderColor: LS.border,
			},
			"&:hover fieldset": {
				borderColor: "rgba(153, 0, 0, 0.45)",
			},
			"&.Mui-focused fieldset": {
				borderColor: LS.red,
			},
			"&.Mui-disabled": {
				opacity: 0.55,
			},
		},
		"& .MuiInputLabel-root": {
			color: LS.textMuted,
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: LS.redLight,
		},
		"& .MuiInputAdornment-root .MuiSvgIcon-root": {
			color: LS.textMuted,
		},
		"& .MuiFormHelperText-root": {
			color: "#ff9999",
		},
	},
	submit: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
		padding: "12px 0",
		borderRadius: 12,
		fontWeight: 700,
		fontSize: "0.95rem",
		textTransform: "none",
		background: `linear-gradient(135deg, ${LS.redDark} 0%, ${LS.red} 50%, ${LS.redLight} 100%)`,
		color: "#fff",
		boxShadow: `0 8px 28px ${LS.redGlow}`,
		transition: "transform 0.2s ease, box-shadow 0.2s ease",
		"&:hover": {
			background: `linear-gradient(135deg, ${LS.red} 0%, ${LS.redLight} 100%)`,
			boxShadow: "0 12px 32px rgba(153, 0, 0, 0.45)",
			transform: "translateY(-1px)",
		},
		"&:disabled": {
			background: "rgba(80, 40, 45, 0.6)",
			color: "rgba(255,255,255,0.45)",
			boxShadow: "none",
			cursor: "not-allowed",
		},
	},
	authLink: {
		color: LS.redLight,
		fontWeight: 600,
		"&:hover": {
			color: "#ff9999",
		},
	},
	disabledNotice: {
		marginBottom: theme.spacing(2),
		padding: theme.spacing(1.5, 2),
		borderRadius: 12,
		background: "rgba(153, 0, 0, 0.15)",
		border: `1px solid ${LS.border}`,
		color: LS.textMuted,
		fontSize: 13,
		lineHeight: 1.5,
		textAlign: "center",
	},
	footerNote: {
		marginTop: theme.spacing(3),
		paddingTop: theme.spacing(2),
		borderTop: `1px solid ${LS.border}`,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 8,
		color: LS.textMuted,
		fontSize: 12,
		textAlign: "center",
		flexWrap: "wrap",
	},
}));

export const NewClientContactCard = () => {
	const classes = useAuthPageStyles();
	const { whatsapp, whatsappDisplay, email } = NEW_CLIENT_CONTACT;

	return (
		<div className={classes.newClientCard}>
			<div className={classes.newClientHeader}>
				<BusinessCenterOutlinedIcon style={{ color: "#7dffb0", fontSize: 22 }} />
				<span className={classes.newClientTitle}>Novos clientes</span>
			</div>
			<Typography className={classes.newClientText}>
				Quer contratar o Multi? Fale com a Life Sip Telecom:
			</Typography>
			<div className={classes.contactRow}>
				<WhatsAppIcon />
				<Link
					href={`https://wa.me/${whatsapp}`}
					target="_blank"
					rel="noopener noreferrer"
					className={classes.contactLink}
				>
					WhatsApp {whatsappDisplay}
				</Link>
			</div>
			<div className={classes.contactRow}>
				<EmailOutlinedIcon style={{ fontSize: 18, color: LS.textMuted }} />
				<Link href={`mailto:${email}`} className={classes.contactEmailLink}>
					{email}
				</Link>
			</div>
		</div>
	);
};

const AuthPageLayout = ({
	heroTitle,
	heroSubtitle,
	formTitle,
	formSubtitle,
	children,
	stats = DEFAULT_STATS,
	showNewClientContact = false,
	brandName = "Life Sip Telecom",
	footerChannels = "WhatsApp · Instagram · Facebook · VoIP / PABX",
}) => {
	const classes = useAuthPageStyles();

	return (
		<div className={classes.root}>
			<CssBaseline />
			<div className={`${classes.backgroundGlow} ${classes.glowRed}`} />
			<div className={`${classes.backgroundGlow} ${classes.glowRedDark}`} />
			<div className={`${classes.backgroundGlow} ${classes.glowAccent}`} />

			<section className={classes.heroPanel}>
				<div className={classes.brandRow}>
					<img src={logoWhite} alt={brandName} className={classes.logoLarge} />
					<div className={classes.brandTextWrap}>
						<span className={classes.brandName}>{brandName}</span>
						<span className={classes.brandNameAccent}>Omnichannel + VoIP</span>
					</div>
				</div>

				<span className={classes.brandBadge}>
					<ForumOutlinedIcon style={{ fontSize: 16 }} />
					Plataforma Multi · Life Sip Telecom
				</span>

				<Typography component="h1" className={classes.heroTitle}>
					{heroTitle}
				</Typography>

				<Typography className={classes.heroSubtitle}>{heroSubtitle}</Typography>

				<div className={classes.channelGrid}>
					{CHANNELS.map((channel, index) => (
						<div
							key={channel.key}
							className={classes.channelCard}
							style={{
								animationDelay: `${0.12 + index * 0.14}s, ${0.85 + index * 0.28}s`,
							}}
						>
							<div
								className={`${classes.channelIconWrap} ${classes[channel.className]}`}
							>
								{channel.icon}
							</div>
							<div>
								<div className={classes.channelLabel}>{channel.label}</div>
								<div className={classes.channelHint}>{channel.hint}</div>
							</div>
						</div>
					))}
				</div>

				<div className={classes.statsRow}>
					{stats.map((stat, index) => {
						const Icon = stat.icon;
						return (
							<div
								key={stat.key || stat.label}
								className={classes.statCard}
								style={{ animationDelay: `${index * 0.4}s` }}
							>
								{Icon && (
									<div className={classes.statIconWrap}>
										<Icon style={{ fontSize: 22 }} />
									</div>
								)}
								<strong className={classes.statValue}>{stat.value}</strong>
								<span className={classes.statLabel}>{stat.label}</span>
							</div>
						);
					})}
				</div>
			</section>

			<section className={classes.formPanel}>
				<div className={classes.formCard}>
					<div className={classes.mobileLogoWrap}>
						<img src={logoWhite} alt={brandName} className={classes.logoLarge} />
						<span className={classes.mobileBrandName}>{brandName}</span>
					</div>

					<Typography component="h2" className={classes.formTitle}>
						{formTitle}
					</Typography>
					<Typography className={classes.formSubtitle}>{formSubtitle}</Typography>

					{children}

					{showNewClientContact && <NewClientContactCard />}

					<div className={classes.footerNote}>
						<PhoneInTalkOutlinedIcon style={{ fontSize: 16, color: LS.redLight }} />
						Life Sip Telecom · {footerChannels}
					</div>
				</div>
			</section>
		</div>
	);
};

export default AuthPageLayout;
